// extracted by mini-css-extract-plugin
module.exports = {"table_row":"donationtable_table_row__16nPN","pagination":"donationtable_pagination__1AcDV","edit":"donationtable_edit__2lnYv","delete":"donationtable_delete__ob4cw"};